import makeStyles from '@mui/styles/makeStyles';

interface ImageHoverStyleProps {
  defaultWidth?: string | number;
  defaultHeight?: string | number;
  hoverWidth?: string | number;
  hoverHeight?: string | number;
}

const useStyles = makeStyles(() => ({
  imageContainer: (props: ImageHoverStyleProps) => ({
    width: props.defaultWidth ?? 'auto',
    height: props.defaultHeight ?? 'auto',
  }),
  hovered: (props: ImageHoverStyleProps) => ({
    width: props.hoverWidth ?? 'auto',
    height: props.hoverHeight ?? 'auto',
    zIndex: 1001,
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.5s ease',
    '&:hover': {
      transform: 'scale(1.6)',
    },
  }),
}));

export default useStyles;
